import { BasketPage } from '@thg-commerce/enterprise-pages'

export default BasketPage
